import { i18n } from '@fs/zion-locale'

export default {
  apply: () => i18n.t('internal.watermark.apply', 'Apply'),
  applyWatermark: () => i18n.t('internal.watermark.applyWatermark', 'Apply Watermark'),
  applyWatermarkSuccess: () =>
    i18n.t(
      'internal.watermark.applyWatermarkSuccess',
      'Watermark successfully applied! It may take a few minutes for the images to update in the system.'
    ),
  applyWatermarkError: () =>
    i18n.t(
      'internal.watermark.applyWatermarkError',
      'An error occurred while applying the watermark. Please try again.'
    ),
  applyWatermarkFailure: (message) =>
    i18n.t('internal.watermark.applyWatermarkFailure', 'Failed to apply watermark: {message}', { message }),
  cancel: () => i18n.t('internal.watermark.cancel', 'Cancel'),
  cautionExistingWatermarks: () =>
    i18n.t('internalSearchFields.watermark.cautionExistingWatermarks', 'Caution: Existing Watermarks'),
  continue: () => i18n.t('internalSearchFields.continue.button', 'Continue'),
  errorFetchingPreview: () => i18n.t('internal.watermark.errorFetchingPreview', 'Error fetching watermark preview.'),
  legacyWatermarkParagraph1: () =>
    i18n.t(
      'internalSearchFields.watermark.bodyParagraph1',
      'This image group has legacy watermarks. If you apply a new watermark, the images will end up with both watermarks.'
    ),
  legacyWatermarkParagraph2: () => i18n.t('internalSearchFields.watermark.bodyParagraph2', 'Do you want to continue?'),
  loading: () => i18n.t('internal.watermark.loading', 'Loading...'),
  removeWatermarks: () => i18n.t('internal.watermark.removeWatermarks', 'Remove Watermarks'),
  removeWatermarksDescription: () =>
    i18n.t(
      'internal.watermark.removeWatermarksDescription',
      'All images in the image group will be reprocessed to replace the current distribution version of the images with a new copy of the preservation image. This will remove all watermarks on these images and cannot be undone.'
    ),
  removeWatermarkSuccess: () =>
    i18n.t(
      'internal.watermark.removeWatermarkSuccess',
      'Watermark successfully removed! It may take a few minutes for the images to update in the system.'
    ),
  removeWatermarkError: () =>
    i18n.t(
      'internal.watermark.removeWatermarkError',
      'An error occurred while removing the watermark. Please try again.'
    ),
  removeWatermarkFailure: (message) =>
    i18n.t('internal.watermark.removeWatermarkFailure', 'Failed to remove watermark: {message}', { message }),
  removeSelectedWatermark: () => i18n.t('internal.watermark.removeSelectedWatermark', 'Remove Selected Watermark'),
  searchExistingWatermarks: () => i18n.t('internal.watermark.searchExistingWatermarks', 'Search existing watermarks'),
  selectWatermarkMessage: () =>
    i18n.t(
      'internal.watermark.selectWatermarkMessage',
      'Please select an existing watermark to apply to the entire image group.'
    ),
  watermarkEditor: () => i18n.t('internal.watermark.watermarkEditor', 'Watermark Editor'),
  watermarking: () => i18n.t('internal.watermark.watermarking', 'Watermarking'),
  watermarkingCondition: () =>
    i18n.t(
      'internal.watermark.watermarkingCondition',
      'If the watermark does not exist yet, you will need to create one first in the watermark editor.'
    ),
  watermarkPreview: () => i18n.t('internal.watermark.watermarkPreview', 'Watermark Preview'),
  iUnderstand: () => i18n.t('internal.watermark.iUnderstand', 'I understand'),
}
